import publicRoutes from '@/router/routes/public.js'
import privateAdminRoutes from '@/router/routes/privateAdmin.js'
import privateTercerosRoutes from '@/router/routes/privateTerceros.js'
import privateSagrilaftRoutes from '@/router/routes/privateSagrilaft.js'
import privateCumplimientoRoutes from '@/router/routes/privateCumplimiento.js'

export default publicRoutes.concat(privateAdminRoutes/*,privateTercerosRoutes,privateSagrilaftRoutes,privateCumplimientoRoutes*/)